import createGlobalState from "@ui/lib/createGlobalState";
import * as io from "io-ts";

export const useSearchQuantitiesInput = createGlobalState({
  storage: "session",
  key: "searchQuantitiesInput",
  type: io.string,
  defaultValue: "",
  scoped: true,
});
